<template>
  <div class="expansion-manage">
    <title-bar
      :user-info="userParams"
      @switchUser="switchUser"
      @onReCharge="handleChargo"
    ></title-bar>
    <common-bg-plate class="content">
      <el-tabs v-model="activeName">
        <el-tab-pane v-if="$utils.hasAuth($store, '8', 'menus')" label="功能演示" name="funDemo">
          <channel-page
            ref="channelPage"
            :user-id="userParams.id"
            :chain-id="userParams.chainId"
          ></channel-page>
        </el-tab-pane>
        <el-tab-pane
          v-if="$utils.hasAuth($store, '9', 'menus')"
          label="压力测试"
          name="pressureTest"
        >
          <pressure-test v-if="activeName === 'pressureTest'" ref="stressTest"></pressure-test>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
    <recharge ref="recharge" @getBalance="getBalance"></recharge>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import channelPage from './channelPage'
import pressureTest from './pressureTest'
import recharge from './components/recharge' //充值
import titleBar from './components/titleBar.vue'

export default {
  name: 'Index',
  components: {
    channelPage,
    pressureTest,
    recharge,
    titleBar
  },
  data() {
    return {
      isUser: false,
      activeIndex: -1,
      activeName: 'funDemo',
      userData: [],
      userParams: {}
    }
  },
  watch: {
    '$store.state.expansionDemo.balance'(newValue, oldValue) {
      this.userParams.balance = newValue
    }
  },
  created() {
    this.userParams = JSON.parse(localStorage.getItem('cbaas_expansion_user_info'))
  },
  mounted() {
    this.getBalance()
  },
  methods: {
    handleChargo() {
      this.$refs.recharge.handleOpen(this.userParams)
    },
    //切换用户
    switchUser() {
      this.$router.push({
        name: 'expansionLogin'
      })
    },
    getBalance() {
      let params = {
        chainId: this.userParams.chainId,
        certId: this.userParams.certId
      }
      this.$apis.expansionDemo
        .getUserInfo(params)
        .then(res => {
          if (res) {
            this.userParams = res.data
            this.$store.commit('balanceChange', res.data.balance)
            localStorage.setItem('cbaas_expansion_user_info', JSON.stringify(res.data))
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.expansion-manage {
  @include adaptation(
    (
      --expansion-manage-title-bar-margin-bottom: 20px,
      --expansion-manage-content-unavailable-height: 148px,
      --expansion-manage-content-tabs-header-margin: 0 0 8px
    )
  );
  --expansion-manage-content-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--expansion-manage-content-unavailable-height)
  );
  .expansion-title-bar {
    margin-bottom: var(--expansion-manage-title-bar-margin-bottom);
  }

  .common-bg-plate.content {
    min-height: var(--expansion-manage-content-min-height);

    .el-tabs {
      /deep/ {
        .el-tabs__header {
          margin: var(--expansion-manage-content-tabs-header-margin);
        }

        .el-tabs__content {
          padding: 0;
        }
      }
    }
  }
}
</style>
